export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background p-6">
      <div className="w-full max-w-md rounded-lg border border-border bg-card p-8 shadow-sm sm:p-10">
        <div className="flex w-full flex-col gap-8">{children}</div>
      </div>
    </div>
  );
}
